<template>
    <div class="page">
        <div class="page-shell">
            <div class="status-row">
                <div class="status-item">本机IP：<span class="status-value green">192.168.1.65</span></div>
                <div class="status-item">服务器IP：<span class="status-value yellow">127.0.0.1</span></div>
                <div class="status-item">试室：<span class="status-value yellow">第一试室</span></div>
            </div>

            <div class="hero">
                <div class="hero-title">卫生专业技术资格考试</div>
                <div class="hero-subtitle">本次模拟的是卫生专业技术资格考试流程</div>
            </div>

            <div class="login-card">
                <div class="login-grid">
                    <div class="left-panel">
                        <div class="field-row">
                            <text class="field-label">准考证号</text>
                            <input class="ticket-input" type="text" :value="ticketNo" disabled />
                        </div>

                        <div class="btn-row">
                            <div class="login-btn" @click="goUser">登录</div>
                        </div>
                    </div>

                    <div class="right-panel">
                        <div class="welcome-text">欢迎使用本系统</div>
                        <div class="hint-text">请输入准考证号进入系统</div>
                    </div>
                </div>
            </div>

            <div class="info-grid">
                <div class="seat-card">

                </div>

                <div class="data-card">

                </div>
            </div>

            <div class="footer-text">益题库 机考系统</div>
        </div>
    </div>
</template>
<script>
import LoginBox from "@/components/LoginBox";

export default {
    components: {
        LoginBox,
    },
    data() {
        return {
            showLogin: false,
            id: 0,
            ticketNo: '1001'
        };
    },
    mounted: function () {
        var query = this.$route.query;
        if (query.paper_id) {
            this.id = query.paper_id;
        }
    },
    methods: {
        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },


        goUser() {
            if (this.IsUsersLogin()) {
                this.$router.push({
                    path: "/meco/yiwei/user",
                    query: {
                        paper_id: this.id,
                    },
                });
            }
        },


        closeBox(e) {
            this.showLogin = false;
        },
    }
}
</script>
<style scoped>
.page {
    min-height: 100%;
    background: linear-gradient(180deg, #2b8fd4 0%, #1f79c7 48%, #1460a9 100%);
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.page {
    min-height: 100vh;
    padding: 22px 24px 0;
    box-sizing: border-box;
    background:
        radial-gradient(circle at top left, rgba(255, 255, 255, 0.14) 0, rgba(255, 255, 255, 0) 34%),
        linear-gradient(180deg, #2b8fd4 0%, #1f79c7 48%, #1460a9 100%);
}

.page-shell {
    max-width: 1280px;
    min-height: calc(100vh - 32px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 72px;
    font-size: 15px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.92);
    letter-spacing: 0.5px;
    padding: 0 150px;
}

.status-value {
    font-weight: 700;
}

.status-value.green {
    color: #86f35f;
}

.status-value.yellow {
    color: #ffe057;
}

.hero {
    padding-top: 18px;
    text-align: center;
}

.hero-title {
    font-size: 54px;
    line-height: 1.08;
    font-weight: 800;
    color: #d6e9ff;
    text-shadow: 0 4px 0 rgba(16, 73, 133, 0.55);
    letter-spacing: 12px;
    margin: 10px 0;
}

.hero-subtitle {
    font-size: 18px;
    line-height: 1.35;
    color: #d6ff41;
    text-shadow: 0 2px 0 rgba(20, 92, 129, 0.45);
    margin-top: 20px;
    letter-spacing: 8px;
}

.login-card {
    background: linear-gradient(180deg, rgba(235, 244, 250, 0.98) 0%, rgba(220, 234, 244, 0.97) 100%);
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: 0 18px 40px rgba(12, 60, 109, 0.14);
    box-sizing: border-box;
}

.login-card {
    width: min(1120px, 100%);
    margin: 28px auto 0;
    padding: 40px 36px 30px;
}

.login-grid {
    display: grid;
    grid-template-columns: 1.45fr 1fr;
    gap: 24px;
    align-items: center;
}

.left-panel {
    padding-right: 20px;
}

.field-row {
    display: flex;
    align-items: center;
    gap: 24px;
}

.field-label {
    font-size: 28px;
    line-height: 1.2;
    color: #0f6ba8;
    letter-spacing: 1px;
    flex-shrink: 0;
}

.ticket-input {
    width: min(100%, 420px);
    height: 52px;
    padding: 0 18px;
    border: 1px solid #5f6c76;
    background: #f0efef;
    font-size: 24px;
    color: #4b4b4b;
    box-sizing: border-box;
}

.btn-row {
    padding-top: 36px;
    padding-left: 192px;
}

.login-btn {
    width: 110px;
    height: 42px;
    border: 1px solid #666666;
    border-radius: 4px;
    background: linear-gradient(180deg, #ffffff 0%, #ececec 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #4a4a4a;
    cursor: pointer;
}

.right-panel {
    text-align: right;
}

.welcome-text {
    font-size: 28px;
    line-height: 1.3;
    color: #ff6800;
    margin-bottom: 38px;
}

.hint-text {
    font-size: 25px;
    line-height: 1.4;
    color: #0d6ba8;
}

.info-grid {
    width: min(1120px, 100%);
    margin: 14px auto 0;
    display: grid;
    grid-template-columns: 1.1fr 0.86fr;
    gap: 14px;
}

.seat-card {
    min-height: 390px;
    background: url("https://www.yitku.com//new_app/exam/yw_01.png") no-repeat center center;
    background-size: contain;
}

.card-label {
    position: relative;
    font-size: 22px;
    color: rgba(255, 255, 255, 0.95);
}

.seat-number {
    position: relative;
    margin-top: 34px;
    text-align: center;
    font-size: 200px;
    line-height: 1;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.95);
}

.data-card {
    background: url("https://www.yitku.com//new_app/exam/yw_02.png") no-repeat center center;
    background-size: contain;

}

.data-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 18px;
    margin-top: 4px;
}

.check-badge {
    position: relative;
    width: 56px;
    height: 56px;
    flex-shrink: 0;
}

.check-circle {
    position: absolute;
    inset: 6px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 30%, #ffd5a6 0%, #ff9e4d 46%, #ff5c00 100%);
    box-shadow: 0 4px 10px rgba(255, 101, 0, 0.28);
}

.check-hook {
    position: absolute;
    background: linear-gradient(180deg, #befe6d 0%, #58d60a 100%);
    border-radius: 999px;
    transform-origin: left center;
}

.check-hook.short {
    left: 12px;
    top: 30px;
    width: 16px;
    height: 7px;
    transform: rotate(40deg);
}

.check-hook.long {
    left: 22px;
    top: 34px;
    width: 34px;
    height: 7px;
    transform: rotate(-45deg);
}

.data-title {
    font-size: 28px;
    line-height: 1.3;
    font-weight: 700;
    color: #ff6f16;
}

.data-item {
    margin-top: 78px;
    text-align: center;
    font-size: 22px;
    line-height: 1.5;
    color: #ff7d2d;
}

.data-item.second {
    margin-top: 34px;
}

.footer-text {
    margin-top: auto;
    padding-top: 18px;
    text-align: center;
    font-size: 18px;
    color: rgba(232, 243, 255, 0.88);
    letter-spacing: 2px;
}

@media screen and (max-width: 1200px) {
    .hero-title {
        font-size: 58px;
    }

    .hero-subtitle {
        font-size: 24px;
    }

    .field-label,
    .welcome-text,
    .data-title {
        font-size: 24px;
    }
}

@media screen and (max-width: 960px) {
    .page {
        padding-left: 16px;
        padding-right: 16px;
    }

    .status-row {
        gap: 24px;
        flex-wrap: wrap;
    }

    .hero-title {
        font-size: 44px;
    }

    .hero-subtitle {
        font-size: 20px;
    }

    .login-card {
        padding: 24px 18px 22px;
    }

    .login-grid,
    .info-grid {
        grid-template-columns: 1fr;
    }

    .left-panel {
        padding-right: 0;
    }

    .field-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
    }

    .ticket-input {
        width: 100%;
    }

    .btn-row {
        padding-left: 0;
        display: flex;
        justify-content: center;
    }

    .right-panel {
        text-align: center;
        padding-top: 18px;
    }

    .welcome-text {
        margin-bottom: 18px;
    }

    .seat-card,
    .data-card {
        min-height: 260px;
    }

    .seat-number {
        font-size: 140px;
    }

    .data-item {
        margin-top: 42px;
    }
}
</style>